export const transactionTableTypes = {
  transactions: 'transactions',
  invoices: 'invoices',
  payments: 'payments',
  creditMemos: 'credit-memos',
  debitMemos: 'debit-memos',
  refunds: 'refunds',
};
